<template>
  <div>

    <el-row v-for="(item, index) in advert_details_arrway" :key="index" class="row">
      <el-col :span="24">

        <div style="display: flex;justify-content: space-around;">
          <div class="box-img">
            <el-image style="width: 200px; height: 200px" :src="item.cover_img.url"></el-image>
            <p>封面图片</p>
          </div>
          <div class="box-img">
            <el-image style="width: 200px; height: 200px" :src="item.logo_img.url"></el-image>
            <p>logo图片</p>
          </div>
          <div class="box-img">
            <el-image style="width: 200px; height: 200px" :src="item.list_img.url"></el-image>
            <p>列表图片</p>
          </div>
        </div>


        <div style="width: 50%;display: inline-block;" class="section">
          <span>链接地址:</span>
          <span>{{ item.link }}</span>
        </div>

        <div style="width: 50%;display: inline-block;" class="section">
          <span>广告名称:</span>
          <span>{{ item.name }}</span>
        </div>


        <div style="width: 50%;display: inline-block;" class="section">
          <span>创建时间:</span>
          <span>{{ item.time.YmdHis }}</span>
        </div>

        <div style="width: 50%;display: inline-block;" class="section">
          <span>修改时间:</span>
          <span>{{ item.edit_time.YmdHis }}</span>
        </div>

        <div class="section">
          <span>广告内容:</span>
          <div v-html="item.content" style="display: inline-block;"></div>
        </div>


        <div class="section">
          <span>备注:</span>
          <span>{{ item.remarks }}</span>
        </div>
      </el-col>
    </el-row>
  </div>

</template>

<script>
  var _this;
  export default {
    props: {
      'isShow': Boolean,
      'data': ''
    },
    watch: {

      isShow: {
        immediate: true,
        handler: function (newData, oldData) {

          console.log(this.data);
          this.advert_details_arrway.length = 0;

          for (let i = 0; i < this.data.length; i++) {

            // 请求广告详情
            this.$post(
                "/advert/getAdvertDetails", {
                  advert_code: this.data[i]
                }
              )
              .then(res => {

                this.advert_details_arrway.push(res.data);

                console.log(this.advert_details_arrway);


              }).catch((err) => {

              })

          }

        }



      },
    },
    data() {
      return {

        show: false,

        advert_details_arrway: [],


      };
    },
    created() {

      _this = this;

    },
    methods: {


      // 关闭方法
      closeDialog() {

        _this.show = false;

      },

    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }

  .avatar-uploader img {
    display: block;
    width: 100%;
    height: 100%;
  }

  .verify_remarks {
    font-size: 14px;
    color: #606266;
  }

  .quill-editor {
    width: 80%;
  }

  .adver-list,
  .adver-selection {
    display: flex;
    flex-wrap: wrap;
    max-height: 300px;
    overflow-y: auto;
  }

  .adver-selection {
    margin-bottom: 50px;
  }

  .adver-list {
    max-height: 500px;
  }

  .adver-list h4,
  .adver-selection h4 {
    width: 100%;
  }

  .adver-list .adver,
  .adver-selection .adver {
    width: 23%;
    padding: 10px;
    box-sizing: border-box;
    cursor: pointer;
    border: 1px solid #ccc;
    border-radius: 10px;
    margin: 10px;
    transition: .5s;
  }

  .adver-list .adver:hover,
  .adver-selection .adver:hover {
    border: 1px solid #409EFF;
    background-color: #409EFF;
  }

  .time-box {
    font-size: 14px;
    margin-top: 15px;
    display: flex;
    justify-content: space-around;
    border-top: 1px solid #ccc;
    padding: 5px 0;
  }

  .row {
    background-color: #f0f0f0;
    padding: 20px;
    box-sizing: border-box;
    margin: 20px 0;
    border-radius: 10px;
  }

  .box-img {
    width: 30%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 20px;
  }

  .box-img p {
    width: 100%;
    text-align: center;
    margin-top: 10px;
  }

  .section {
    margin: 10px 0;
  }
</style>